import Vue from 'vue'

import withRender from './search-field.html'
import './search-field.scss'

export default withRender(Vue.extend({
  props: {
    describedBy: { type: String },
    fieldId: { type: String }, // when using input where label has "for" attribute
    labelId: { type: String }, // when using div where label has an id
    multiline: Boolean,
    placeholder: String, // placeholder text, only used in input field (!multiline)
    showSearchIcon: Boolean,
    value: String
  },
  methods: {
    clearText() {
      this.$emit('input', '')
      this.$nextTick(() => this.$refs.field.focus())
    },
    update(e) {
      this.$emit('input', this.multiline ? e.target.innerText : e.target.value)
    }
  },
  watch: {
    value() {
      if (this.multiline && this.value.length === 0) {
        this.$refs.field.innerText = ''
      }
    }
  }
}))



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!(webpack)-strip-block!./src/objects/form/search-field.ts